import {getContent, bulkUpdate, getShortUrl} from '@/libs/api/api'
import {message, loader, getImageUrl, onError, navigateTo, copyElement, copyText} from '@/libs/helper'
import {cloneDeep, isEmpty, uniqBy} from 'lodash'
import constants from '@/libs/constant/constants'

export default {
    name: 'ArticleForm',
    props: {},
    beforeMount() {
        this.$store.dispatch('setShowTableSettings', false)
        this.$store.dispatch('setContainer', true)
    },
    mounted() {
        this.getContent()
        this.getShortenedUrl()
    },
    components: {
        RegisteredList: () => import(/* webpackChunkName: "group-admin" */'@/components/component/RegisteredList/RegisteredList.vue'), 
        AdminSearch:() => import(/* webpackChunkName: "group-admin" */'@/components/component/TestAdmin/AdminSearch/AdminSearch.vue')
    },
    data() {
        return {
            category: 'ARTICLE',
            content: 'content',
            copyText,
            des: {},
            authors: [],
            address: {},
            shortUrl: '',
            publisher: {},
            author: {},
            formData: {},
            metaData: {},
            contentData: {},
            article_image: {},
            metaToAdd: {},
            getUserData: {},
            isEmpty,
            getImageUrl,
            publication: {},
            date: {},
            copyright: {},
            publicationToAdd: {},
            publisherToAdd: {},
            constants,
            navigateTo,
            activeTab: constants.PUBLISHER_TABS.CONTENT_DB,
            onError,
            pickerOptions: {
                disabledDate (date) {
                  return new Date(date) > new Date()
                }
            }
        }
    },
    methods: {
        getContent: async function () {
            loader(this, true)
            try {
                this.formData = await getContent(this.$route.params.id)
                this.contentData = cloneDeep(this.formData)
                this.setValues(this.contentData)
                loader(this, false)
            }
            catch(error){
                console.warn('ERROR->', error)
                loader(this, false)
            }
           },
           updateFormData (type, data) {
            switch (type) {
                case 'TITLE':
                    this.formData.title ? this.formData.title = cloneDeep(data.title) : this.formData['title'] = cloneDeep(data.title) 
                    this.formData.sub_title ? this.formData.sub_title = cloneDeep(data.subtitle) : this.formData['sub_title'] = cloneDeep(data.subtitle) 
                break
                case 'DESCRIPTION': 
                this.formData.description ? this.formData.description = cloneDeep(data.description) : this.formData['description'] = cloneDeep(data.description) 
                break
                case 'AUTHORS':
                    this.formData.authors ? this.formData.authors = cloneDeep(data) : this.formData['authors'] = cloneDeep(data)
                break
                case 'PUBLICATION':
                    this.formData.publication ? this.formData.publication = cloneDeep(data) : this.formData['publication'] = cloneDeep(data)
                break
                case 'PUBLISHER':
                    this.formData.publisher ? this.formData.publisher = cloneDeep(data) : this.formData['publisher'] = cloneDeep(data)
                break
                case 'PUB_DATE':
                    this.formData.pub_date ? this.formData.pub_date = cloneDeep(data.pub_date) : this.formData['pub_date'] = cloneDeep(data.pub_date) 
                break
                case 'ARTICLE_IMAGE': 
                this.formData.main_image_url ? this.formData.main_image_url = cloneDeep(data.main_image_url) : this.formData['main_image_url'] = cloneDeep(data.main_image_url) 
                this.formData.caption ? this.formData.caption = cloneDeep(data.caption) : this.formData['caption'] = cloneDeep(data.caption) 
                this.formData.main_image_copy_right ? this.formData.main_image_copy_right = cloneDeep(data.image_copyright) : this.formData['main_image_copy_right'] = cloneDeep(data.image_copyright) 
                break
            }
            this.contentData = cloneDeep(this.formData)
            this.setValues(this.contentData)        
        },
        setValues (data) {
            this.metaData = {
                title: data.title || '',
                subtitle: data.sub_title || ''
            }
            this.des = {description: data.description || ''}

            this.authors = data.authors || []

            this.publisher = data.publisher || {}

            this.publication = data.publication || {}
            
            this.article_image = {
                image_url: data.main_image_url || '',
                main_image_url: data.main_image_url || '',
                caption: data.caption || '',
                image_copyright: data.main_image_copy_right || ''
            }
            this.date = {
                pub_date: data.pub_date
            }
            this.time = this.getDate(data.pub_date)

            this.copyright = {
                copy_right: data.copy_right || ''
            }
           
        },
        validateTitle (rule, value, callback) {
            let pattern = /^[^a-zA-Z0-9]+$/;
            if (!isEmpty(value) && pattern.test(value)) callback(new Error('Invalid characters')) 
            else callback() 
        },
        editTitleForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) return
                loader(this, true)
                let meta = cloneDeep(this.metaData)
                if (this.formData.title !== meta.title || this.formData.sub_title !== meta.subtitle) {
                    let body = {
                        title: meta.title,
                        sub_title: meta.subtitle,
                        entity_ids: [this.$route.params.id]
                    }
                    bulkUpdate(this.content, body).then(() => {
                        this.updateFormData('TITLE', this.metaData)
                        message(this, constants.messageType.SUCCESS, "Updated Successfully")
                        loader(this, false)
                    }).catch(error => {
                        loader(this, false)
                        return error
                    })
                }
            })
            
        },
        editDescription (formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) return
                loader(this, true)
                if (this.formData.description !== this.des.description) {
                    loader(this, true)
                    bulkUpdate(this.content, {description: this.des.description, entity_ids: [this.$route.params.id]}).then(() => {
                        this.updateFormData('DESCRIPTION', this.des)
                        message(this, constants.messageType.SUCCESS, "Updated Successfully")
                        loader(this,false)
                    }).catch(error => {
                        loader(this, false)
                        return error
                    })
                }
            })
        },
        setMetaToAdd (item) {
            this.metaToAdd = item
        },
        setPublicationToAdd (item) {
            this.publicationToAdd = item
        },
        setPublisherToAdd (item) {
            this.publisherToAdd = item
        },
        addAuthor: async function () {
            let ids = this.authors.map(author => author._id)
            if (isEmpty(this.metaToAdd) || new Set(ids).has(this.metaToAdd._id)) {
                this.metaToAdd = {}
                return
            }
            try {
                loader(this, true)
                let authors = cloneDeep(this.authors)
                authors.push(this.metaToAdd)
                let body = {
                    entity_ids: [this.$route.params.id],
                    authors: {
                        action: 'ADD',
                        author_id: [this.metaToAdd._id]
                    }
                }
                await bulkUpdate(this.content, body)
                this.authors = uniqBy(authors, '_id')
                this.updateFormData('AUTHORS', this.authors)
                message(this, constants.messageType.SUCCESS, "Updated Successfully")
                loader(this, false)
            } catch (error) {
                console.error(error)
                loader(this, false)
            } 
            this.metaToAdd = {}
        },
        removeAuthor: async function (item) {
            try {
                loader(this, true)
                let authors = cloneDeep(this.authors)
                authors = authors.filter(author => author._id !== item._id)
                let body = {
                    authors: {
                        action: 'REMOVE',
                        author_id: [item._id]
                    },
                    entity_ids: [this.$route.params.id]
                }
                await bulkUpdate(this.content, body)
                this.authors = authors
                this.updateFormData('AUTHORS', this.authors)
                message(this, constants.messageType.SUCCESS, "Updated Successfully")
                loader(this, false)
            } catch (error) {
                loader(this, false)
                console.error(error)
            }  
        },
        addPublication: async function () {
            if (isEmpty(this.publicationToAdd) || this.publication._id === this.publicationToAdd._id) {
                this.publicationToAdd = {}
                return
            }
            try {
                loader(this, true)
                await bulkUpdate(this.content, {publication: this.publicationToAdd._id, entity_ids: [this.$route.params.id]}) 
                this.publication = cloneDeep(this.publicationToAdd)
                this.updateFormData('PUBLICATION', cloneDeep(this.publication))
                message(this,constants.messageType.SUCCESS, 'Updated Successfully')
                loader(this, false)
            } catch (error) {
                loader(this, false)
                console.error(error)
            } 
            this.publicationToAdd = {}
        },
        removePublication: async function () {
            try {
                loader(this, true)
                await bulkUpdate(this.content, {publication: '', entity_ids: [this.$route.params.id]})     
                this.updateFormData('PUBLICATION', {})
                this.publication = {}
                message(this,constants.messageType.SUCCESS, 'Updated Successfully')
                loader(this, false)
            } catch (error) {
                loader(this, false)
                console.error(error)
            }  
        },
        addPublisher: async function () {
            if (isEmpty(this.publisherToAdd) || this.publisher._id === this.publisherToAdd._id) {
                this.publisherToAdd = {}
                return
            }
            try {
                loader(this, true)
                await bulkUpdate(this.content, {publisher: this.publisherToAdd._id, entity_ids: [this.$route.params.id]}) 
                this.publisher = cloneDeep(this.publisherToAdd)
                this.updateFormData('PUBLISHER', cloneDeep(this.publisher))
                message(this,constants.messageType.SUCCESS, 'Updated Successfully')
                loader(this, false)
            } catch (error) {
                loader(this, false)
                console.error(error)
            } 
            this.publisherToAdd = {}
        },
        removePublisher: async function () {
            try {
                loader(this, true)
                await bulkUpdate(this.content, {publisher: '', entity_ids: [this.$route.params.id]})     
                this.updateFormData('PUBLISHER', {})
                this.publisher = {}
                message(this,constants.messageType.SUCCESS, 'Updated Successfully')
                loader(this, false)
            } catch (error) {
                loader(this, false)
                return error
            }  
        },
        getArticleImage (article) {
            if (article.image_url !== '') return article.image_url
            return '@/assets/images/No_Image_Available.png'
        },
        editImageForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) return
                let data = cloneDeep(this.article_image)
                if (this.formData.main_image_copy_right !== data.image_copyright || this.formData.caption !== data.caption || this.formData.main_image_url !== data.main_image_url) {
                    loader(this, true)
                    let body = {
                        caption: this.article_image.caption,
                        main_image_url: this.article_image.main_image_url,
                        main_image_copy_right: this.article_image.image_copyright,
                        entity_ids: [this.$route.params.id]
                    }
                    bulkUpdate(this.content, body).then(() => {
                        this.updateFormData('ARTICLE_IMAGE', this.article_image)
                        message(this, constants.messageType.SUCCESS, "Updated Successfully")
                        loader(this, false)
                    }).catch(error => {
                        console.error(error)
                        loader(this, false)
                    })
                }
            })
        },
        getDate (date) {
            if (date !== undefined && date !== null) {
            let d = new Date(date)
            return ('0' + d.getDate()).slice(-2) + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' +
                d.getFullYear() + ' ' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2)
            }
        },
        editDate () {
            if (this.formData.pub_date !== this.date.pub_date) {
                loader(this, true)
                let pub_date = this.date.pub_date === null ? '': this.date.pub_date
                bulkUpdate(this.content, {pub_date: pub_date, entity_ids: [this.$route.params.id]}).then(() => {
                    this.updateFormData('PUB_DATE', this.date)
                    message(this, constants.messageType.SUCCESS, "Updated Successfully")
                    loader(this, false)
                }).catch(error => {
                    loader(this, false)
                    console.error(error)
                })
            }
        },
        disabledTitleForm () {
            if (this.formData.title !== this.metaData.title || this.formData.sub_title !== this.metaData.subtitle) {
                return false
            }
            return true
        },
        disabledDescriptionForm () {
            if (this.formData.description !== this.des.description) {
                return false
            }
            return true
        },
        disabledImageForm () {
            if (this.formData.main_image_copy_right !== this.article_image.image_copyright || this.formData.caption !== this.article_image.caption || this.formData.main_image_url !== this.article_image.main_image_url) {
                return false
            }
            return true
        },
        disabledDate () {
            if (this.formData.pub_date !== this.date.pub_date) return false
            return true
        },
        handleCommand (command) {
            switch (command) {
                case 'COPY':
                    copyElement(this.$route.params.id)
                break
                case 'REMOVE': 
                    this.removeMeta()
                break
            }
        },
        removeMeta () {
            let body = {
                entity_ids: [this.$route.params.id],
                delete_from_ecosystem: true
            }
            bulkUpdate(this.content, body).then(() => {
                this.$store.dispatch('setCallPublishers', {label: 'Articles', className: 'info'})
            }).catch(error => {
                message(this, constants.messageType.ERROR, error.message)
            })
        },
         /**
         * to get the short url of this listing
         */
        getShortenedUrl () {
            let body = {
                type: this.category,
                type_id: this.$route.params.id
            }
            getShortUrl(body).then(response => {
                this.shortUrl = response.short_url || ''
            }).catch(error => {
                console.error(error)
            })
        },
        copyShortUrl () {
            if (this.shortUrl === '' || this.shortUrl === null || this.shortUrl === undefined) return
            copyElement(`https://${this.shortUrl}`)
        }
    }
}